module.exports = __webpack_public_path__ + "static/media/shield-icon.3a867c17.svg";